import { RefreshCw } from 'lucide-react';
import { useVersionCheck } from '@/hooks/useVersionCheck';

export function VersionUpdateBanner() {
  const { updateAvailable } = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm animate-in slide-in-from-bottom-5 fade-in duration-300">
      <div className="bg-primary text-primary-foreground rounded-lg shadow-lg border p-4 flex items-start gap-3">
        <RefreshCw className="h-5 w-5 mt-0.5 shrink-0" />
        <div className="flex-1 space-y-1">
          <p className="text-sm font-medium">New version available</p>
          <p className="text-xs opacity-90">
            A new version has been released. Refresh to get the latest features and fixes.
          </p>
        </div>
        <button
          onClick={() => window.location.reload()}
          className="shrink-0 bg-primary-foreground text-primary text-xs font-medium px-3 py-1.5 rounded-md hover:opacity-90 transition-opacity"
        >
          Refresh
        </button>
      </div>
    </div>
  );
}
